import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from "element-ui/lib/locale/lang/en.js";
import './assets/element-variables.scss'

import VueClipboard from 'vue-clipboard2'

import ba from 'vue-ba'


Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.use(ba, 'd15a91292a704edb2ad849bec8a0e115')

Vue.use(ElementUI, {locale})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  let username = localStorage.getItem("username")
  let moduleAuthorityList = JSON.parse(localStorage.getItem("moduleAuthorityList"))

  if (username != '' && username != null && moduleAuthorityList) {
    //console.log(moduleAuthorityList);
    //primer3使用
    let primer3_use = moduleAuthorityList.find(item => item.moduleName == 'primer3' && item.moduleAuthority == 'use')
    //console.log(primer3_use);
    //jbrowse使用
    let jbrowse_use = moduleAuthorityList.find(item => item.moduleName == 'jbrowse' && item.moduleAuthority == 'use')
    //console.log(jbrowse_use);
    //blast使用
    let blast_use = moduleAuthorityList.find(item => item.moduleName == 'blast' && item.moduleAuthority == 'use')
    //console.log(blast_use);
    //用户管理
    let user_manager = moduleAuthorityList.find(item => item.moduleName == 'user' && item.moduleAuthority == 'manager')
    //console.log(user_manager);
    if (to.path == "/usermanage" && user_manager == null) {
      ElementUI.MessageBox({
        title: 'Notice',
        message: 'Permission Denied！'
      })

      // next({
      //   path: "/"
      // });
    } else if (to.path.indexOf("blast") !== -1 && blast_use == null) {
      ElementUI.MessageBox({
        title: 'Notice',
        message: 'Permission Denied！'
      })

      // next({
      //   path: "/"
      // });
    } else if (to.path == "/primer" && primer3_use == null) {
      ElementUI.MessageBox({
        title: 'Notice',
        message: 'Permission Denied！'
      })
      // next({
      //   path: "/"
      // });
    } else {
      next()
    }
  }
  // else if (username != '' && username != null ) {}
  else {
    //console.log(to.path);
    if (to.path == "/") {
      next()
    } else if (to.path == "/login") {
      next()
    } else if (to.path == "/register") {
      next()
    } else if (to.path == "/updatepwd") {
      next()
    } else if (to.path == "/vipServer") {
      next()
    } else if (to.path == "/contactus") {
      next()
    } else if (to.path == "/news") {
      next()
    } else {
      ElementUI.MessageBox({
        title: 'Notice',
        message: 'Please login first！'
      })
      next({
        path: "/login"
      })
    }

  }

})



new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
